module.exports = __webpack_public_path__ + "static/media/7_Peace of mind_CN.e22f74f5.txt";